import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";

const empty = { current_password: "", new_password: "", confirm: "" };

export default function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.put("/auth/me/password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password changed");
      setForm(empty);
      setOpen(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <>
      <Button variant="ghost" size="sm" className="w-full justify-start mb-2 text-muted-foreground" data-testid="change-password-btn" onClick={() => setOpen(true)}>
        <KeyRound className="w-4 h-4 mr-2" /> Change password
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog">
          <DialogHeader><DialogTitle style={{ fontFamily: "Outfit" }}>Change your password</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div className="space-y-1.5"><Label>Current password</Label>
              <Input type="password" data-testid="cp-current" value={form.current_password} onChange={set("current_password")} required className="min-h-[44px]" /></div>
            <div className="space-y-1.5"><Label>New password (min 8 characters)</Label>
              <Input type="password" data-testid="cp-new" value={form.new_password} onChange={set("new_password")} minLength={8} required className="min-h-[44px]" /></div>
            <div className="space-y-1.5"><Label>Confirm new password</Label>
              <Input type="password" data-testid="cp-confirm" value={form.confirm} onChange={set("confirm")} required className="min-h-[44px]" /></div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)} data-testid="cp-cancel">Cancel</Button>
              <Button type="submit" disabled={busy} data-testid="cp-submit">{busy ? "Saving…" : "Update password"}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
